var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13,23.3922611 C13,26.1869082 14.4306624,28.6988138 16.7004015,30.4196048 C16.8420877,30.5253988 17.2147039,30.7866071 17.2441452,30.8043954 C18.2101874,31.5281014 17.2809468,33.2208055 16.3167447,34.2590848 C15.7840415,34.8339301 15.8677651,35.0127501 16.5633155,34.8329939 C19.9490632,33.9613636 20.5783707,32.2798942 22.0642355,32.6403428 C22.0651556,32.6403428 22.0669957,32.641279 22.0679157,32.641279 C22.6953831,32.7358383 23.3403312,32.7854585 24,32.7854585 C30.0750251,32.7854585 35,28.5799125 35,23.3922611 C35,18.205546 30.0750251,14 24,14 C17.9240549,14 13,18.205546 13,23.3922611 Z",
    id: "chat-path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketplace---DTR-Concepts",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Services-Copy",
    transform: "translate(-164.000000, -732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(41.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(123.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "message",
    fillRule: "nonzero",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat-path-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chat-path-1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.79d60cda.svg";
export { ForwardRef as ReactComponent };